import $ from 'jquery';
import imageMapResize from 'image-map-resizer';
import 'slick-carousel/slick/slick';
import "../../../../modal.js";

$(function() {
    // nav-tabs
    $('.nav-tabs .nav-item > a').on('click', function(e) {
        e.preventDefault()
        let $this = $(this);
        if (!$this.parent().hasClass('active')) {
            $this.parent().siblings().removeClass('active')
            $this.parent().addClass('active')

            let target = $this.attr('href');
            $('.tabs-content .tab').removeClass('active')
            $(target).addClass('active');
        }
        try {
            $('.main-slider').slick('setPosition');
        } catch (err) {}
    })
    let tab = window.location.hash;
    if(tab) {
        $(`a[href='${tab}']`).trigger('click')
    }


    imageMapResize();

    $('map area').on('click', function() {
        let id = $(this).attr('href')
        console.log('id: ', id)
    })

    $('.main-slider').slick({
        speed: 500,
        slidesToShow: 1,
        arrows: true,
        slidesToScroll: 1,
        infinite: false,
        asNavFor: '.sub-slider',
    });
    var slidecount = $('.sub-slider .item').length;
    $('.sub-slider').slick({
        dots: false,
        slidesToShow: slidecount,
        infinite: false,
        autoplay: false,
        asNavFor: '.main-slider',
        focusOnSelect: true
    });
})
